import ContratoInterceptor from '../ContratoInterceptor'

const api = new ContratoInterceptor()

export default {
  addProfissionaisExecutantes(contratoId: String, profissionaisExecutantes) {
    return api.post(`/contratos/${contratoId}/profissionais-executantes`, profissionaisExecutantes)
  },

  deleteProfissionalExecutante(contratoId: String, profissionalExecutanteId) {
    return api.delete(`/contratos/${contratoId}/profissionais-executantes/${profissionalExecutanteId}`)
  },

  getProfissionaisExecutantes() {
    return api.get(`/profissionais-executantes`)
  },

  getProfissionaisExecutantesByPrestadorId(prestadorId: String) {
    return api.get(`/profissionais-executantes/prestador/${prestadorId}/user`)
  },

  getProfissionalExecutanteByContratoId(contratoId: String) {
    return api.get(`/profissionais-executantes/${contratoId}`)
  },

  getProfissionalExecutanteById(id: String) {
    return api.get(`/profissionais-executantes/getbyid/${id}`)
  },
  
  getProfissionalExecutanteGestorId(contratoId: String, gestorId: String) {
    return api.get(`/profissionais-executantes/${contratoId}/${gestorId}`)
  },

  getPapelProfissionalExecutante(userId: String, contratoId: String) {
    return api.get(`/contrato/papel-profissional/${userId}/${contratoId}`)
  }
}
